module.exports = __webpack_public_path__ + "video-28fcc8e2d17c.mov";